/* eslint-disable max-len */
import React from 'react';

const MassOperationsMenuClose: React.FC<object> = () => {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.72246 4.72254C1.92874 4.51632 2.20848 4.40047 2.50016 4.40047C2.79184 4.40047 3.07157 4.51632 3.27786 4.72254L8.00016 9.44484L12.7225 4.72254C12.8239 4.61747 12.9453 4.53367 13.0795 4.47602C13.2137 4.41837 13.3581 4.38803 13.5041 4.38676C13.6502 4.38549 13.795 4.41332 13.9302 4.46863C14.0654 4.52394 14.1882 4.60562 14.2915 4.7089C14.3948 4.81218 14.4765 4.935 14.5318 5.07019C14.5871 5.20537 14.6149 5.35022 14.6136 5.49628C14.6124 5.64233 14.582 5.78668 14.5244 5.92088C14.4667 6.05508 14.3829 6.17646 14.2779 6.27794L9.55556 11.0002L14.2779 15.7225C14.4782 15.93 14.5891 16.2079 14.5866 16.4963C14.5841 16.7847 14.4684 17.0606 14.2645 17.2645C14.0605 17.4685 13.7846 17.5842 13.4962 17.5867C13.2078 17.5892 12.9299 17.4783 12.7225 17.2779L8.00016 12.5556L3.27786 17.2779C3.07039 17.4783 2.79253 17.5892 2.50411 17.5867C2.2157 17.5842 1.9398 17.4685 1.73586 17.2645C1.53191 17.0606 1.41622 16.7847 1.41371 16.4963C1.41121 16.2079 1.52208 15.93 1.72246 15.7225L6.44476 11.0002L1.72246 6.27794C1.51624 6.07166 1.40039 5.79192 1.40039 5.50024C1.40039 5.20856 1.51624 4.92882 1.72246 4.72254Z"
                fill="#F44336"
            />
        </svg>
    );
};

export default MassOperationsMenuClose;